import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { instrumentWebVitals } from './lib/web-vitals.js';
import './styles/master-tokens.css'; // the ONE brand-accent + data-semantic source (D2); both scopes consume it
import './styles/globals.css';
// react-grid-layout v2 ships its own CSS only — react-resizable styles are
// bundled inline since v2 (kickoff text predated the v2 release).
import 'react-grid-layout/css/styles.css';

// V1 MASTER-PLATFORM: direct render; NO `/api/auth/me` bootstrap.
//
// PHASE-3C-PIVOT: add auth check before render:
//   1. fetch('/api/auth/me')
//   2. if 401 → window.location.href = '/personas'
//   3. if 200 → store user + tenant_id in auth-slice; then render
//
// See .claude/PHASE-3C-AUTH-PIVOT-CHECKLIST.md §2 for the canonical activation
// substrate. markets-os-api `/api/auth/me` route is already in place
// (requireAuth-gated); frontend integration is the work.

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element missing from index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// MOS-2A-UX G4 G2 RUM substrate per Q-G4-2 ratified (Option α: api +
// TimescaleDB + Grafana). web-vitals onLCP/onINP/onCLS ship to
// POST /api/telemetry/web-vitals (PUBLIC at V1; auth-bound at MOS-1U).
instrumentWebVitals();
